import styled from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";

import { CssIcon } from "styles/helpers/layout";

export const StyledSubjectProgressList = styled.ul<Props>`
  list-style: none;
  margin-top: 1rem;
  margin-left: 0.5rem;
  padding: 0 0.5rem 0 1.5rem;
  border-left: solid 1px ${(props: Props) => props.theme.palette.neutral._900};

  width: 100%;
  display: flex;
  row-gap: 0.75rem;
  flex-direction: column;
  grid-column: 1 / span 3;
`;

export interface StyledSubjectProgressListItemProps extends Props {
  $isCompleted?: boolean;
}

export const StyledSubjectProgressListItem = styled.li<StyledSubjectProgressListItemProps>`
  display: grid;
  column-gap: 1rem;
  align-items: center;
  grid-template-columns: 1fr 4rem;

  color: ${(props: Props) => props.theme.palette.neutral._300};
  font-size: ${(props: Props) => props.theme.font.size._12};

  > :last-child {
    text-align: right;
    ${(props: StyledSubjectProgressListItemProps) =>
      props.$isCompleted &&
      `
      color: ${props.theme.palette.feedback.success.brand};
    `}
  }

  ${CssIcon} {
    color: ${(props: Props) => props.theme.palette.feedback.success.brand};
  }
`;
